import * as signalR from "@microsoft/signalr";
import { onCheatingDetected } from "common/signalR";
import { routes } from "utilities/routing/generatedRoutes";

export const signalRMiddleware = () => (next: any) => (action: any) => next(action);

export const signalRStart = () => {
  const hubConnection = new signalR
    .HubConnectionBuilder()
    .withUrl(site.deploymentValues.signalREndpoint)
    .configureLogging(site.deploymentValues.signalRBrowserDebugLevel)
    .withAutomaticReconnect()
    .build();

  window.signalRConnections = {
    hub: hubConnection
  };

  onCheatingDetected(() => {
    window.location.href = routes.account_ReprimandedForCheating().absolute;
  });

  hubConnection.start();
};
